// пункты меню в сайдбаре
import { useNavigate } from 'react-router-dom';
import { useUserStore } from 'storeZustand';
import { useShallow } from 'zustand/react/shallow';

import {
	HomeOutlined,
	DollarOutlined,
	MoneyCollectOutlined,
	LoginOutlined,
	BookOutlined,
	DatabaseOutlined,
	PieChartOutlined,
	ProjectOutlined,
	ScheduleOutlined,
	InfoOutlined,
	ClockCircleOutlined,
	TeamOutlined,
	TruckOutlined,
	ShoppingOutlined,
	SignatureOutlined,
	UngroupOutlined,
	WalletOutlined,
	ReadOutlined,
	ProductOutlined,
	PartitionOutlined,
	ShoppingCartOutlined
} from '@ant-design/icons';

const useMenuItems = () => {
	const navigate = useNavigate();

	// Загрузка данных текущего пользователя
	const [
		isSuperAdmin,
		isOutstaff,
		isCallCenter
	] = useUserStore(useShallow((state) => [
		state.isSuperAdmin,
		state.isOutstaff,
		state.isCallCenter
	]));

	const getItem = (label, key, icon) => ({ key, label, icon });

	const handleMenuClick = (e) => {
		navigate(`/${e.key}`);
	}

	// меню медцентров
	const medicineItems = [
		getItem('Главная', 'dashboard', <HomeOutlined />),
		getItem('Оплата записей', 'payment', <DollarOutlined />),
		getItem('Оплата абонем.', 'payment-subscriptions', <MoneyCollectOutlined />),
		getItem('Приход/Расход', 'cash', <LoginOutlined />),
		getItem('Все заявки', 'service-requests', <BookOutlined />),
		getItem('Все записи', 'bookings', <DatabaseOutlined />),
		getItem('Статистика', 'statistics', <PieChartOutlined />),
		getItem('Услуги', 'services-list', <ProjectOutlined />),
		getItem('Абонементы', 'subscriptions', <ScheduleOutlined />),
		getItem('Глоссарий', 'glossary', <InfoOutlined />),
		getItem('График работы', 'work-schedule', <ClockCircleOutlined />),
		getItem('Сотрудники', 'staff', <TeamOutlined />),
		getItem('SKU', 'storeGoods', <TruckOutlined />),
		getItem('Наименование', 'storeGoodsName', <ShoppingOutlined />),
		getItem('Категория', 'storeGoodsCategory', <SignatureOutlined />),
		getItem('Размер', 'storeGoodsSize', <UngroupOutlined />),
		getItem('Материал', 'storeGoodsMaterial', <WalletOutlined />),
	];

	// меню коллцентра
	const callcenterItems = [
		getItem('Главная', 'dashboard', <HomeOutlined />),
		getItem('Все заявки', 'service-requests', <BookOutlined />),
		getItem('Все записи', 'bookings', <DatabaseOutlined />),
		getItem('Услуги', 'services-list', <ProjectOutlined />),
		getItem('Абонементы', 'subscriptions', <ScheduleOutlined />),
		getItem('Глоссарий', 'glossary', <InfoOutlined />),
		getItem('График работы', 'work-schedule', <ClockCircleOutlined />),
		getItem('Сотрудники', 'staff', <TeamOutlined />),
	]

	// меню аутов
	const outstaffItems = [
		getItem('Заявки', 'service-requests-outstaff', <BookOutlined />),
		getItem('Договоры', 'contracts', <DatabaseOutlined />),
		getItem('Заказы', 'contractOrders', <ShoppingCartOutlined />),
		getItem('Оплаты', 'contractOrderPayments', <DollarOutlined />),
		getItem('Доверенности', 'procuratory', <ReadOutlined />),
		getItem('Компании', 'companies', <DatabaseOutlined />),
		getItem('Адреса', 'company-address', <TruckOutlined />),
		getItem('Создать документ', 'template', <BookOutlined />),
		getItem('Список шаблонов', 'template-fields', <ProductOutlined />),
		getItem('Набор шаблонов', 'templates-set', <PartitionOutlined />),
	]

	const items = (isOutstaff && outstaffItems) || (isCallCenter && callcenterItems) || medicineItems;

	return { items, handleMenuClick };
};

export default useMenuItems;